import { AdminLayout, SidebarLink } from '@britishcouncil/react-admin';
import React from 'react';

import { OidcContext } from '@britishcouncil/react-oidc-auth';
import { LOGOS } from 'const';
import { Navbar, Sidebar } from 'core';
import { AppSettingsContext } from 'settings';
interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { signoutRedirect } = OidcContext.useAuth();

  return (
    <AppSettingsContext.Consumer>
      {({ planExamsUrl }) => (
        <AdminLayout
          appName="Event Planner"
          theme="blue"
          sidebarItems={<Sidebar />}
          isSidebarLoading={false}
          appLogo={LOGOS.EventPlannerLogoUrl}
          topBarContent={<Navbar />}
          applications={[
            {
              id: 1,
              name: 'Plan Exams',
              url: planExamsUrl,
              image: LOGOS.PlanExamsLogoUrl,
            },
          ]}
          bottomSidebarItems={
            <SidebarLink
              to="#"
              icon="power off"
              name="Logout"
              as="button"
              onClick={() => signoutRedirect()}
            />
          }
        >
          {children}
        </AdminLayout>
      )}
    </AppSettingsContext.Consumer>
  );
};
